import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { generateJWTToken } from "src/app/core/helpers/jwt-token.utils";
import { Observable } from "rxjs";

@Injectable({
  providedIn: 'root',
})
export class PublisherUpdatesService {

  constructor(private http: HttpClient) {}

  public loadAllUpdates(accountId: any, userId: any): Observable<any> {
    const payloadObj = {
      iss: 'https://platform.renderseo.com', // Might have to change this url....
      sub: userId, // user id
      account_id: accountId,
      iat: new Date().getTime(),
      exp: new Date().getTime() + 3 * 6000,
    };
    const jwtToken = generateJWTToken(payloadObj, '2c4c4d06f0b35b921039d9df2725205d981ac00bf196eb71b02ce7571432e30a');
    const headers = new HttpHeaders().set('Authorization', `${jwtToken}`);
    const url: string = `https://io.renderseo.com/publisher-updates`;
    return this.http.get(url, { headers: headers });
  }
}
